import React from "react";
import { Drawer, DialogTitle, IconButton } from "@mui/material";
import OperadoresForm from "./OperadoresForm";
import { Cancel } from "@mui/icons-material";
import { styles } from "utils/apis";


const AddOperadores = ({ mode, open, handleClose }) => {

    return (
        <>
            <Drawer
                anchor={"bottom"}
                open={open}
                onClose={handleClose}
                sx={styles}     
            >
                <DialogTitle sx={{display: "flex", justifyContent: "flex-end", padding: 0}}>
                    <IconButton onClick={handleClose} sx={{color:"purple"}}>
                        <Cancel />
                    </IconButton>
                </DialogTitle>
                <OperadoresForm mode={mode} handleClose={handleClose} />
            </Drawer>
        </>
    )
}
export default AddOperadores;